import { atom } from "recoil";

/**
 * @var appReady Remote Configの初期化と取得が完了しているかどうか
 * @var requestReady Firebase Authでユーザがログイン状態かどうか（TRUE: ログイン状態、FALSE: 未ログイン状態）
 * @var authReady Firebase Authからユーザー情報を取得できているかどうか
 * @var remoteConfig Remote Configの値
 */
export type FirebaseStore = {
  appReady: boolean;
  requestReady: boolean;
  authReady: boolean;
  remoteConfig: {
    isMaintenanceMode: boolean;
    maintenanceDateString: string;
  };
};

export const firebaseStore = atom<FirebaseStore>({
  key: "firebase",
  default: {
    appReady: false,
    requestReady: false,
    authReady: false,
    remoteConfig: {
      isMaintenanceMode: false,
      maintenanceDateString: "",
    },
  },
});
